import { emitter, EmitterEvent } from '@app/store/events';
import type { IAlert } from '@store/types';
import { useCallback, useEffect, useRef, useState } from 'react';

import Alert from './Alert';

export interface StoreAlertsProps {
  alerts: IAlert[];
}

export default function StoreAlerts(props: StoreAlertsProps) {
  const [alerts, setAlerts] = useState(props.alerts ?? []);

  const hasRun = useRef<boolean>(false);

  const onClose = useCallback(
    (id: string) => setAlerts(state => state.filter(r => r.id !== id)),
    []
  );

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const add = (alert: IAlert) => {
      if (!alert) return;
      setAlerts(state => [alert, ...state]);
    };

    emitter.on(EmitterEvent.Alert, add);

    return () => {
      if (hasRun.current) return;

      emitter.off(EmitterEvent.Alert, add);
    };
  }, []);

  if (alerts.length === 0) return <></>;

  return (
    <div className="w-full flex flex-col gap-2 p-2" role="alert">
      {alerts.map(alert => (
        <Alert key={alert.id} {...alert} onClose={onClose} />
      ))}
    </div>
  );
}
